<div class="form-fill-container">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center">
        <div class="flex justify-content-center align-items-center flex-column">
            <i class="pi pi-spin pi-spinner text-4xl mb-3"></i>
            <p class="text-lg">{{ 'LOADING_FORM' | translate }}</p>
        </div>
    </div>

    <!-- Error State -->
    <div *ngIf="hasError" class="text-center">
        <div class="flex justify-content-center align-items-center flex-column">
            <i class="pi pi-exclamation-triangle text-4xl text-red-500 mb-3"></i>
            <h2 class="text-xl mb-2">{{ 'ERROR_LOADING_FORM' | translate }}</h2>
            <p class="text-gray-600">{{ 'PLEASE_TRY_AGAIN_LATER' | translate }}</p>
        </div>
    </div>

    <!-- Expired State -->
    <div *ngIf="isExpired" class="text-center">
        <div class="flex justify-content-center align-items-center flex-column">
            <i class="pi pi-clock text-4xl text-orange-500 mb-3"></i>
            <h2 class="text-xl mb-2">{{ 'FORM_EXPIRED' | translate }}</h2>
            <p class="text-gray-600">{{ 'FORM_NO_LONGER_AVAILABLE' | translate }}</p>
        </div>
    </div>

    <!-- Submitted State -->
    <div *ngIf="isSubmitted" class="text-center">
        <div class="flex justify-content-center align-items-center flex-column">
            <i class="pi pi-check-circle text-4xl text-green-500 mb-3"></i>
            <h2 class="text-xl mb-2">{{ 'FORM_SUBMITTED' | translate }}</h2>
            <p class="text-gray-600">{{ 'THANK_YOU_FOR_SUBMISSION' | translate }}</p>
        </div>
    </div>

    <!-- Form Ready State -->
    <div *ngIf="isReady" class="form-content">
        <!-- Survey.js Component -->
        <survey *ngIf="surveyModel" [model]="surveyModel"></survey>
    </div>

</div>